export const AGENCY = 'msg_codes_agreementType_agency';
export const FIRST_PARTY_PUBLISHER = 'msg_codes_agreementType_firstPartyPublisher';
export const THIRD_PARTY_CONTRACTUAL = 'msg_codes_agreementType_thirdPartyFreeAllocation';
export const THIRD_PARTY_RATECARD = 'msg_codes_agreementType_thirdPartyPublisher';
